import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import LoginNoticeImg from 'assets/images/login-notice.png';

import classes from './LoginNotice.module.scss';

const LoginNotice = () => {
	return (
		<div
			className={`${classes['login-notice-wrapper']} d-flex flex-column align-items-center justify-content-center`}>
			<img className="px-5" src={LoginNoticeImg.src} alt="login-required" />
			<h5 className="py-3">Please log in to your account</h5>
			<LinkButton to="/get-started" kind="primary-color" className={'px-5 py-3'}>
				Log in / Register
			</LinkButton>
		</div>
	);
};

export default LoginNotice;
